import classes from "./Article.module.css";
import galleryClasses from "../Gallery/Photos.module.css";
import galleryHelpers from "../../store/gallery-helper.js";
import { useState } from "react";
import Modal from "../UI/Modal";

const Article = (props) => {
  // props: text, photos
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState("");
  let photos = [];
  if (props.photos) {
    photos = props.photos.map((photo) => (
      <img
        key={photo}
        onClick={() =>
          galleryHelpers.zoomInHandler(photo, setIsZoomedIn, setCurrentPhoto)
        }
        src={photo}
        alt=""
      />
    ));
  }

  let textContent = "";
  if (props.text) {
    textContent = props.text.split("\n").map((t) => {
      return (
        <p key={t.substring(2, 8)} className={classes.text}>
          {t}
        </p>
      );
    });
  }

  return (
    <div className={props.className}>
      {props.header && <h1 className={classes.header}>{props.header}</h1>}
      {textContent}
      {photos.length > 0 && (
        <div className={galleryClasses.wrapper}>{photos}</div>
      )}
      {isZoomedIn && photos.length > 0 && (
        <Modal
          onHidePhoto={() => {
            galleryHelpers.zoomOutHandler(setIsZoomedIn);
          }}
          photo={currentPhoto}
        />
      )}
      {props.comment && (
        <p className={classes.textHighlight}>{props.comment}</p>
      )}
    </div>
  );
};

export default Article;
